/**
 * Validates whether a given string is a valid Base64-encoded data URI.
 *
 * This function checks if the input string contains a "base64," prefix,
 * then attempts to decode the Base64 portion using `atob()`. If decoding succeeds,
 * the original string is returned. Otherwise, `undefined` is returned.
 *
 * Common use case: validating image or SVG data URIs before using them in rendering.
 *
 * @param {string} [str] - The string to validate.
 * @returns {string | undefined} The original string if it's a valid Base64 data URI; otherwise, `undefined`.
 */
export function validateBase64DataString(str) {
    if (typeof str !== 'string')
        return undefined;
    const base64PrefixMatch = str.match(/^data:[^;]+;base64,/i); // matches basic Base64 data URI with MIME type and captures the Base64 content
    if (!base64PrefixMatch)
        return undefined;
    const base64Content = str.replace(base64PrefixMatch[0], ''); // extract the Base64 content captured by the regex
    if (!base64Content.trim())
        return undefined;
    try {
        atob(base64Content);
        return str;
    }
    catch (_a) {
        return undefined;
    }
}
